import { selectedCVCPanelModel } from '@/stores//panels';
import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';

const useIsHighlightPanel = (panelId: string) => {
  const selectedPanelId = useRecoilValue(selectedCVCPanelModel);
  return useMemo(() => selectedPanelId === panelId, [selectedPanelId, panelId]);
};
export default useIsHighlightPanel;
